import { OwlModule } from "ngx-owl-carousel";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/app/shared/shared.module";
import { WebpageHostingComponent } from "./webpage-hosting.component";
import { RevolutionSliderWpComponent } from "./revolution-slider-wp/revolution-slider-wp.component";
import { HostingListComponent } from "./hosting-list/hosting-list.component";
import { ProcessComponent } from "./process/process.component";
import { ServiceTabComponent } from "./service-tab/service-tab.component";
import { PricingModule } from "../pricing-plan/pricing.module";
const routes: Routes = [
    { path: '', component: WebpageHostingComponent }
  ];
@NgModule({
    declarations: [
        WebpageHostingComponent,
        RevolutionSliderWpComponent,
        HostingListComponent,
        ProcessComponent,
        ServiceTabComponent
    ],
    imports: [
        HttpClientModule,
        CommonModule,
        OwlModule,
        RouterModule,
        SharedModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
        WebpageHostingComponent
      ]
  })
  export class WebpageHostingModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }